export var CheckboxGroupLayout;
(function (CheckboxGroupLayout) {
    CheckboxGroupLayout["Horizontal"] = "horizontal";
    CheckboxGroupLayout["Vertical"] = "vertical";
})(CheckboxGroupLayout || (CheckboxGroupLayout = {}));
//# sourceMappingURL=types.js.map